import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.0008 4.28113C13.7402 4.28122 16.9205 6.66598 18.1102 9.9989C16.9206 13.332 13.7403 15.7176 10.0008 15.7177C6.26075 15.7177 3.07791 13.3323 1.88849 9.9989C3.078 6.66564 6.26086 4.28113 10.0008 4.28113Z",
  stroke: "currentColor",
  "stroke-width": "1.3"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "10",
  cy: "9.99912",
  r: "2.75",
  stroke: "currentColor",
  "stroke-width": "1.3"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }